const WIDGET_ID = "result-share-of-search-funnel" as const;

const GRAPH_HEIGHT = 400 as const;

export { WIDGET_ID, GRAPH_HEIGHT };
